// @ts-ignore
import { Sortable, Plugins } from '@shopify/draggable';

import {
  createAddItemFormData,
  createDeleteItemFormData,
  createUpdateListFormData,
  listActionStandard,
} from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';

class DragDrop {
  public flexContainers: NodeListOf<HTMLElement>;

  public sortables: Array<any> = [];

  public filterPills: NodeListOf<HTMLElement>;

  public draggingElement: HTMLElement | null;

  public isInitialized: boolean;

  public isDragging: boolean = false;

  public isMouseOver: HTMLElement | null;

  checkSortableStatus() {
    if (window.innerWidth > 1024 && !this.isInitialized) {
      this.isInitialized = true;
      this.initSortables();
    } else if (window.innerWidth <= 1024 && this.isInitialized) {
      this.isInitialized = false;
      this.sortables.forEach((sortable) => sortable.destroy());
    }
  }

  async handleMoveProduct(elementId: string | undefined, listIdTo: string | undefined, listIdFrom: string | undefined, quantity: string | undefined, hidePrice: string | undefined) {
    try {
      await listActionStandard(createDeleteItemFormData(elementId || '', listIdFrom || ''));

      const newItemFormData = createAddItemFormData(elementId || '', listIdTo || '');
      newItemFormData.append('fields[plaintext_title_1]', quantity || '');
      newItemFormData.append('fields[plaintext_title_2]', hidePrice || '');

      await listActionStandard(newItemFormData);

      messageBoxSuccess({
        contentDe: 'Produkt(e) wurde(n) erfolgreich verschoben.',
        contentEn: 'Successfully moved product(s).',
      });

      setTimeout(() => {window.location.reload()}, 200);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Produkt(e) konnte(n) nicht verschoben werden.',
        contentEn: 'An error appeared. Could not move product(s).',
      });
    }
  }

  initSortables() {
    const sortable = new Sortable(this.flexContainers, {
      draggable: '.m-wishlist-product-teaser',
      mirror: {
        constrainDimensions: true,
      },
      scrollable: {
        speed: 50,
      },
      plugins: [Plugins.SortAnimation],
    });

    sortable.on('drag:start', (e: any) => {
      if (e.sensorEvent.target.tagName.toLowerCase() !== 'img') {
        e.cancel();
      } else {
        e.data.source.classList.add('is-dragging');
        document.body.style.cursor = 'grabbing';
        this.isDragging = true;
      }
    });

    sortable.on('drag:stop', () => {
      document.body.style.cursor = '';
      this.isDragging = false;
    });

    sortable.on('sortable:stop', (e) => {
      // @ts-ignore
      const data = e.data;

      setTimeout(() => {
        const teasers = data.oldContainer.querySelectorAll('.m-wishlist-product-teaser:not(.is-dragging)');
        const order: Array<string | undefined> = [];

        teasers.forEach((teaser: HTMLElement) => {
          order.push(teaser.dataset.elementId);
        });

        const updateListFormData = createUpdateListFormData(data.oldContainer.dataset.listId);

        updateListFormData.append('fields[plaintext_title_1]', JSON.stringify({order: order}));
        listActionStandard(updateListFormData);

        if (data.newContainer != data.oldContainer) {
          const teasers = data.newContainer.querySelectorAll('.m-wishlist-product-teaser:not(.is-dragging)');
          const order: Array<string | undefined> = [];

          teasers.forEach((teaser: HTMLElement) => {
            order.push(teaser.dataset.elementId);
          });

          const updateListFormData = createUpdateListFormData(data.newContainer.dataset.listId);

          updateListFormData.append('fields[plaintext_title_1]', JSON.stringify({order: order}));
          listActionStandard(updateListFormData);

          this.handleMoveProduct(data.dragEvent.data.source.dataset.elementId, data.newContainer.dataset.listId, data.oldContainer.dataset.listId, data.dragEvent.data.source.dataset.quantity, data.dragEvent.data.source.dataset.hidePrice);
        }
      }, 50);
    });

    this.sortables.push(sortable);
  }

  bindings() {
    this.filterPills.forEach((pill) => {
      pill.addEventListener('mouseover', () => {
        if (this.isDragging) {
          this.isMouseOver = pill;

          this.draggingElement = document.querySelector('.is-dragging.draggable-mirror');

          this.draggingElement?.classList.add('is-over-dropzone');
        }
      });

      pill.addEventListener('mouseout', () => {
        if (this.isDragging) {
          this.isMouseOver = null;

          const draggingElement = document.querySelector('.is-dragging.draggable-mirror');

          draggingElement?.classList.remove('is-over-dropzone');
        }
      });
    });

    window.addEventListener('mouseup', () => {
      if (this.draggingElement && this.isMouseOver) {
        this.draggingElement.style.transform = 'scale(0)';
        this.handleMoveProduct(this.draggingElement.dataset.elementId, this.isMouseOver.dataset.listId, this.draggingElement.dataset.listId, this.draggingElement.dataset.quantity, this.draggingElement.dataset.hidePrice);
      }
    });

    this.checkSortableStatus();
    window.addEventListener('resize', this.checkSortableStatus.bind(this));
  }

  cache() {
    this.flexContainers = document.querySelectorAll('.l-wishlist .o-wishlist-teaser__grid');
    this.filterPills = document.querySelectorAll('.m-wishlist-group-filter .a-filter-pill, .m-wishlist-section-filter .a-filter-pill');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default DragDrop;
